module.exports = __webpack_public_path__ + "img/9788983924278.75e8e007.jpg";